import { useStore } from '../store';

export { useStore };
